// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../../node_modules/mdb-organization-chart/css/organization-chart.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../../node_modules/mdb-treeview/css/treeview.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cerberushtml .cerberus, .cerberus html .cerberus {
  font-size: 16px;
}

.cerberusinput, .cerberus input {
  max-width: unset;
}

.cerberus {
  --mdb-font-size: 14px;
  --mdb-font-family: m_1cregular;
  --mdb-btn-font-family: m_1cregular;
  --mdb-body-font-family: m_1cregular;
  font-size: var(--mdb-font-size);
}
.cerberus .btn {
  text-transform: none;
  font-size: 14px;
}

.cerberus .bg-dark, .cerberus.bg-dark {
  background-color: #212529 !important;
}

.cerberush1, .cerberus h1, .cerberush2, .cerberus h2, .cerberush3, .cerberus h3, .cerberush4, .cerberus h4, .cerberush5, .cerberus h5, .cerberush6, .cerberus h6, .cerberus.h1, .cerberus .h1, .cerberus.h2, .cerberus .h2, .cerberus.h3, .cerberus .h3, .cerberus.h4, .cerberus .h4, .cerberus.h5, .cerberus .h5, .cerberus.h6, .cerberus .h6 {
  margin-bottom: 0px !important;
}

.cerberus.row, .cerberus .row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.cerberus.account-created-modal .modal-body, .cerberus .account-created-modal .modal-body {
  min-height: unset !important;
}

.cerberus.fade, .cerberus .fade {
  opacity: unset;
}

.cerberus.response-blur, .cerberus .response-blur {
  filter: blur(8px);
  -webkit-filter: blur(8px);
}

.cerberus.modal.fade, .cerberus .modal.fade {
  opacity: 1 !important;
  z-index: 1051 !important;
}

.cerberus.modal-backdrop.fade, .cerberus .modal-backdrop.fade {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.8) !important;
}

.cerberus.modal-body::after, .cerberus .modal-body::after {
  display: none;
}

.cerberus.authentication-dropdown-tabs .nav-tabs, .cerberus .authentication-dropdown-tabs .nav-tabs {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.cerberus.authentication-dropdown-tabs .nav-item, .cerberus .authentication-dropdown-tabs .nav-item {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}

.cerberus.authentication-dropdown-tabs .nav-link, .cerberus .authentication-dropdown-tabs .nav-link {
  background: #212529 !important;
  color: #fff !important;
  border: 1px solid transparent !important;
  border-bottom-color: rgba(255, 255, 255, 0.3) !important;
  border-radius: 5px 5px 0 0 !important;
  margin-right: 0 !important;
  position: relative !important;
  z-index: 1 !important;
  transition: all 0.25s ease !important;
}

.cerberus.authentication-dropdown-tabs .nav-link:hover, .cerberus .authentication-dropdown-tabs .nav-link:hover,
.cerberus.authentication-dropdown-tabs .nav-link.active, .cerberus .authentication-dropdown-tabs .nav-link.active {
  z-index: 2 !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-bottom-color: #212529 !important;
}

.cerberusbody.discover-popover-open, .cerberus body.discover-popover-open {
  overflow: hidden;
}

.cerberus.site-footer-modal, .cerberus .site-footer-modal {
  min-height: 90vh;
}

.cerberus.modal-dialog, .cerberus .modal-dialog {
  margin-top: 56px !important;
}

.cerberus.modal-content, .cerberus .modal-content {
  max-height: 90vh;
}

.cerberus.site-footer-modal a, .cerberus .site-footer-modal a {
  text-decoration: none;
  color: #2b2b2b;
}

.cerberus.slide-container, .cerberus .slide-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.cerberus.slide-content, .cerberus .slide-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: transform 0.5s ease;
}

.cerberus.slide-content.enter-left, .cerberus .slide-content.enter-left {
  transform: translateX(-100%);
}

.cerberus.slide-content.enter-right, .cerberus .slide-content.enter-right {
  transform: translateX(100%);
}

.cerberus.slide-content.active, .cerberus .slide-content.active {
  transform: translateX(0);
}

.cerberus#discover-dropdown .collapsing > *, .cerberus #discover-dropdown .collapsing > *, .cerberus#discover-dropdown .collapsing, .cerberus #discover-dropdown .collapsing {
  height: unset !important;
}

.cerberus.rotate-180, .cerberus .rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.25s ease;
}

.cerberus#siteSearch li, .cerberus #siteSearch li {
  cursor: pointer;
  transition: background 0.3s ease;
}

.cerberus#siteSearch li:hover, .cerberus #siteSearch li:hover,
.cerberus#siteSearch li.selected, .cerberus #siteSearch li.selected {
  background: rgba(255, 255, 255, 0.3);
}

.cerberus#searchPhrase, .cerberus #searchPhrase {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  height: unset !important;
  font-family: inherit !important;
}

.cerberus#searchPhrase::placeholder, .cerberus #searchPhrase::placeholder {
  letter-spacing: 0.4em;
}

.cerberus#search-close, .cerberus #search-close {
  position: sticky;
  top: 0;
  background-color: inherit;
}

.cerberus.discover-learn-course, .cerberus .discover-learn-course,
.cerberus.discover-lounge-case-study, .cerberus .discover-lounge-case-study {
  transition: background 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
}

.cerberus.discover-learn-course:hover, .cerberus .discover-learn-course:hover,
.cerberus.discover-lounge-case-study:hover, .cerberus .discover-lounge-case-study:hover {
  background: rgba(255, 255, 255, 0.2);
}

.cerberus.collapse-chevron, .cerberus .collapse-chevron {
  transition: transform 0.3s ease;
}

.cerberus.collapse-chevron.rotated, .cerberus .collapse-chevron.rotated {
  transform: rotate(180deg);
}

.cerberus.discover-carousel-indicator, .cerberus .discover-carousel-indicator {
  border: 2px solid transparent;
  text-transform: uppercase !important;
  transition: border 0.3s ease, border-color 0.3s ease;
  border-bottom: none !important;
  font-size: 0.875em !important;
}

.cerberus.discover-carousel-indicator:hover, .cerberus .discover-carousel-indicator:hover,
.cerberus.discover-carousel-indicator.active, .cerberus .discover-carousel-indicator.active {
  border-color: rgba(255, 255, 255, 0.5);
  background: #212529 !important;
}

.cerberus.featured-blog-post, .cerberus .featured-blog-post {
  background: linear-gradient(135deg, #ffca2c, #ff9900);
  color: #000;
  font-weight: 700;
  font-size: 0.75em;
  padding: 0.35em 0.6em;
  border-radius: 0.35em;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
  letter-spacing: 0.5px;
  text-transform: uppercase;
  /* optional subtle border */
  border: 1px solid rgba(255, 255, 255, 0.15);
  /* optional shine … subtle but nice on black */
  backdrop-filter: blur(3px);
}

.cerberusbutton, .cerberus button {
  width: unset;
  height: unset;
}

.cerberus.authentication-enrol-tabs .nav-link, .cerberus .authentication-enrol-tabs .nav-link, .cerberus.authentication-create-tabs .nav-link, .cerberus .authentication-create-tabs .nav-link {
  /*background: #212529 !important;*/
  color: #fff !important;
  border: 1px solid transparent;
  border-bottom-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px 5px 0 0;
  margin-right: 0;
  position: relative;
  z-index: 1;
  transition: all 0.25s ease;
}

.cerberus.authentication-enrol-tabs .nav-link:hover, .cerberus .authentication-enrol-tabs .nav-link:hover,
.cerberus.authentication-enrol-tabs .nav-link.active, .cerberus .authentication-enrol-tabs .nav-link.active,
.cerberus.authentication-create-tabs .nav-link:hover, .cerberus .authentication-create-tabs .nav-link:hover,
.cerberus.authentication-create-tabs .nav-link.active, .cerberus .authentication-create-tabs .nav-link.active {
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  border-bottom-color: #212529 !important;
  background: transparent !important;
}

.cerberus#discover-dropdown, .cerberus #discover-dropdown {
  transform: none !important;
  position: fixed !important;
  top: 56px !important;
}

/* Snowflakes relative to container */
.cerberus.snowflake, .cerberus .snowflake {
  position: absolute; /* relative to container */
  top: -10%; /* start slightly above container */
  z-index: 9999;
  color: #fff;
  font-size: 1em;
  font-family: Arial, sans-serif;
  text-shadow: 0 0 5px #000;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
  pointer-events: none;
  animation-name: snowflakes-shake;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-play-state: running;
}

@keyframes snowflakes-fall {
  0% {
    transform: translateY(-10%) translateX(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(110%) translateX(5px); /* small horizontal drift */
    opacity: 0;
  }
}
.cerberus.snowflake .inner, .cerberus .snowflake .inner {
  animation-name: snowflakes-fall;
  animation-duration: 3s; /* you can randomize per flake */
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

/* Snowflake positions and delays */
.cerberus.snowflake:nth-of-type(1), .cerberus .snowflake:nth-of-type(1) {
  left: 1%;
  animation-delay: 0s;
}

.cerberus.snowflake:nth-of-type(1) .inner, .cerberus .snowflake:nth-of-type(1) .inner {
  animation-delay: 0s;
}

.cerberus.snowflake:nth-of-type(2), .cerberus .snowflake:nth-of-type(2) {
  left: 10%;
  animation-delay: 1s;
}

.cerberus.snowflake:nth-of-type(2) .inner, .cerberus .snowflake:nth-of-type(2) .inner {
  animation-delay: 1s;
}

.cerberus.snowflake:nth-of-type(3), .cerberus .snowflake:nth-of-type(3) {
  left: 20%;
  animation-delay: 0.5s;
}

.cerberus.snowflake:nth-of-type(3) .inner, .cerberus .snowflake:nth-of-type(3) .inner {
  animation-delay: 2s;
}

.cerberus.snowflake:nth-of-type(4), .cerberus .snowflake:nth-of-type(4) {
  left: 30%;
  animation-delay: 2s;
}

.cerberus.snowflake:nth-of-type(4) .inner, .cerberus .snowflake:nth-of-type(4) .inner {
  animation-delay: 3s;
}

.cerberus.snowflake:nth-of-type(5), .cerberus .snowflake:nth-of-type(5) {
  left: 40%;
  animation-delay: 1.5s;
}

.cerberus.snowflake:nth-of-type(5) .inner, .cerberus .snowflake:nth-of-type(5) .inner {
  animation-delay: 2.5s;
}

.cerberus.snowflake:nth-of-type(7), .cerberus .snowflake:nth-of-type(7) {
  left: 60%;
  animation-delay: 2s;
}

.cerberus.snowflake:nth-of-type(7) .inner, .cerberus .snowflake:nth-of-type(7) .inner {
  animation-delay: 3.5s;
}

.cerberus.snowflake:nth-of-type(8), .cerberus .snowflake:nth-of-type(8) {
  left: 70%;
  animation-delay: 1s;
}

.cerberus.snowflake:nth-of-type(8) .inner, .cerberus .snowflake:nth-of-type(8) .inner {
  animation-delay: 2s;
}

.cerberus.snowflake:nth-of-type(9), .cerberus .snowflake:nth-of-type(9) {
  left: 80%;
  animation-delay: 0s;
}

.cerberus.snowflake:nth-of-type(9) .inner, .cerberus .snowflake:nth-of-type(9) .inner {
  animation-delay: 1s;
}

.cerberus.snowflake:nth-of-type(10), .cerberus .snowflake:nth-of-type(10) {
  left: 90%;
  animation-delay: 1.5s;
}

.cerberus.snowflake:nth-of-type(10) .inner, .cerberus .snowflake:nth-of-type(10) .inner {
  animation-delay: 2.5s;
}

.cerberus.snowflake:nth-of-type(11), .cerberus .snowflake:nth-of-type(11) {
  left: 25%;
  animation-delay: 0.5s;
}

.cerberus.snowflake:nth-of-type(11) .inner, .cerberus .snowflake:nth-of-type(11) .inner {
  animation-delay: 1.5s;
}

.cerberus.snowflake:nth-of-type(12), .cerberus .snowflake:nth-of-type(12) {
  left: 65%;
  animation-delay: 2.5s;
}

.cerberus.snowflake:nth-of-type(12) .inner, .cerberus .snowflake:nth-of-type(12) .inner {
  animation-delay: 3.5s;
}

/* Optional shimmer animation for text */
@keyframes shimmer {
  0% {
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3), 0 0 10px #FFCC00, 0 0 15px #D72631;
  }
  50% {
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3), 0 0 20px #FFCC00, 0 0 30px #D72631;
  }
  100% {
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3), 0 0 10px #FFCC00, 0 0 15px #D72631;
  }
}
@media (max-width: 991px) {
  .cerberus.navbar-brand::after, .cerberus .navbar-brand::after {
    margin-left: 10px !important;
    padding-left: 0px !important;
  }
}
@media (max-width: 768px) {
  .cerberus#discover-dropdown, .cerberus #discover-dropdown {
    position: fixed !important;
    transform: none !important;
    top: 56px !important;
    height: calc(100vh - 56px) !important;
  }
  .cerberus#discover-dropdown .cerberus-carousel-indicators, .cerberus #discover-dropdown .cerberus-carousel-indicators {
    display: flex !important;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .cerberus#site-account-dropdown, .cerberus #site-account-dropdown {
    width: 100vw !important;
  }
  .cerberus#site-navbar-content-wrapper, .cerberus #site-navbar-content-wrapper {
    height: calc(100vh - 56px);
  }
  .cerberus#site-navbar-content, .cerberus #site-navbar-content {
    position: fixed;
    top: 56px;
    right: 0px;
    left: 0px;
    bottom: 0px;
  }
  .cerberus.navbar-collapse.collapsing .navbar-collapse-inner, .cerberus .navbar-collapse.collapsing .navbar-collapse-inner, .cerberus.navbar-collapse.show .navbar-collapse-inner, .cerberus .navbar-collapse.show .navbar-collapse-inner {
    height: calc(100vh - 56px);
  }
}
@media (max-width: 480px) {
  .cerberus.nav-tabs > li, .cerberus .nav-tabs > li {
    width: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./cerberus.1.0/src/cerberus.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB;EACI,eAAA;AAAJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;EAKA,+BAAA;AAHJ;AASA;EACI,oBAAA;EACA,eAAA;AAPJ;;AAUA;EACI,oCAAA;AAPJ;;AAUA;EACI,6BAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,4BAAA;AAPJ;;AAeA;EACI,4BAAA;AAZJ;;AAeA;EACI,cAAA;AAZJ;;AAgBA;EACE,iBAAA;EACA,yBAAA;AAbF;;AAiBA;EACI,qBAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,qBAAA;EACA,yCAAA;AAdJ;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,4DAAA;AAdF;;AAkBA;EACE,0BAAA;EACA,2BAAA;AAfF;;AAmBA;EACE,8BAAA;EACA,sBAAA;EACA,wCAAA;EACA,wDAAA;EACA,qCAAA;EACA,0BAAA;EACA,6BAAA;EACA,qBAAA;EACA,qCAAA;AAhBF;;AAoBA;;EAEE,qBAAA;EACE,qDAAA;EACA,uCAAA;AAjBJ;;AAoBA;EACI,gBAAA;AAjBJ;;AAmBA;EACI,gBAAA;AAhBJ;;AAmBA;EACI,2BAAA;AAhBJ;;AAmBA;EACI,gBAAA;AAhBJ;;AAmBA;EACI,qBAAA;EACA,cAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,4BAAA;AAjBF;;AAmBA;EACE,2BAAA;AAhBF;;AAkBA;EACE,wBAAA;AAfF;;AAkBA;EACI,wBAAA;AAfJ;;AAmBA;EACI,yBAAA;EACA,gCAAA;AAhBJ;;AAmBA;EACI,eAAA;EACC,gCAAA;AAhBL;;AAkBA;;EAEI,oCAAA;AAfJ;;AAiBA;EACI,0BAAA;EACA,6BAAA;EACA,wBAAA;EACA,+BAAA;AAdJ;;AAgBA;EACE,qBAAA;AAbF;;AAgBA;EACI,gBAAA;EACA,MAAA;EACA,yBAAA;AAbJ;;AAgBA;;EAEI,gCAAA;EACA,qCAAA;AAbJ;;AAgBA;;EAEI,oCAAA;AAbJ;;AAgBA;EACI,+BAAA;AAbJ;;AAgBA;EACI,yBAAA;AAbJ;;AAeA;EACI,6BAAA;EACA,oCAAA;EACA,oDAAA;EACA,8BAAA;EACA,6BAAA;AAZJ;;AAeA;;EAEI,sCAAA;EACA,8BAAA;AAZJ;;AAgBA;EACI,qDAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,qBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,2CAAA;EAEA,8CAAA;EACA,0BAAA;AAfJ;;AAkBA;EACI,YAAA;EACA,aAAA;AAfJ;;AAmBA;EACI,kCAAA;EACA,sBAAA;EACA,6BAAA;EACA,6CAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,0BAAA;AAhBJ;;AAoBI;;;;EAII,UAAA;EACA,qDAAA;EACA,uCAAA;EACA,sCAAA;EACA,uCAAA;EACA,kCAAA;AAjBR;;AAsBA;EACI,0BAAA;EACA,0BAAA;EACA,oBAAA;AAnBJ;;AAuCA,qCAAA;AACA;EACI,kBAAA,EAAA,0BAAA;EACA,SAAA,EAAA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,gCAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;EACA,6BAAA;AApCJ;;AAuCA;EACI;IACI,yCAAA;IACA,UAAA;EApCN;EAsCE;IACI,UAAA;EApCN;EAsCE;IACI,UAAA;EApCN;EAsCE;IACI,2CAAA,EAAA,2BAAA;IACA,UAAA;EApCN;AACF;AAuCA;EACI,+BAAA;EACA,sBAAA,EAAA,gCAAA;EACA,iCAAA;EACA,mCAAA;AArCJ;;AAwCA,mCAAA;AACA;EAA4B,QAAA;EAAU,mBAAA;AAnCtC;;AAoCA;EAAmC,mBAAA;AAhCnC;;AAiCA;EAA4B,SAAA;EAAW,mBAAA;AA5BvC;;AA6BA;EAAmC,mBAAA;AAzBnC;;AA0BA;EAA4B,SAAA;EAAW,qBAAA;AArBvC;;AAsBA;EAAmC,mBAAA;AAlBnC;;AAmBA;EAA4B,SAAA;EAAW,mBAAA;AAdvC;;AAeA;EAAmC,mBAAA;AAXnC;;AAYA;EAA4B,SAAA;EAAW,qBAAA;AAPvC;;AAQA;EAAmC,qBAAA;AAJnC;;AAOA;EAA4B,SAAA;EAAW,mBAAA;AAFvC;;AAGA;EAAmC,qBAAA;AACnC;;AAAA;EAA4B,SAAA;EAAW,mBAAA;AAKvC;;AAJA;EAAmC,mBAAA;AAQnC;;AAPA;EAA4B,SAAA;EAAW,mBAAA;AAYvC;;AAXA;EAAmC,mBAAA;AAenC;;AAdA;EAA6B,SAAA;EAAW,qBAAA;AAmBxC;;AAlBA;EAAoC,qBAAA;AAsBpC;;AArBA;EAA6B,SAAA;EAAW,qBAAA;AA0BxC;;AAzBA;EAAoC,qBAAA;AA6BpC;;AA5BA;EAA6B,SAAA;EAAW,qBAAA;AAiCxC;;AAhCA;EAAoC,qBAAA;AAoCpC;;AAlCA,wCAAA;AACA;EACA;IAAK,+EAAA;EAsCH;EArCF;IAAM,+EAAA;EAwCJ;EAvCF;IAAO,+EAAA;EA0CL;AACF;AAZA;EACE;IACE,4BAAA;IACA,4BAAA;EAcF;AACF;AAVA;EACI;IACI,0BAAA;IACA,0BAAA;IACA,oBAAA;IACA,qCAAA;EAYN;EAVE;IACI,wBAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EAYN;EAVE;IACI,uBAAA;EAYN;EAVE;IACI,0BAAA;EAYN;EAVG;IACG,eAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;EAYN;EATE;IACI,0BAAA;EAWN;AACF;AANA;EACE;IACE,sBAAA;EAQF;AACF","sourcesContent":["\r\n@import '~mdb-organization-chart/css/organization-chart.min.css'; // plugin\r\n@import '~mdb-treeview/css/treeview.min.css'; // plugin\r\n\r\nhtml .cerberus{\r\n    font-size:16px;\r\n}\r\ninput{\r\n    max-width:unset;\r\n}\r\n\r\n.cerberus {\r\n    --mdb-font-size: 14px;\r\n    --mdb-font-family : m_1cregular;\r\n    --mdb-btn-font-family : m_1cregular;\r\n    --mdb-body-font-family : m_1cregular;\r\n\r\n    \r\n  \r\n\r\n    font-size: var(--mdb-font-size);\r\n    *{\r\n        // font-size : inherit;\r\n    }\r\n}\r\n\r\n.cerberus .btn{\r\n    text-transform:none;\r\n    font-size:14px;\r\n}\r\n\r\n.cerberus .bg-dark, .cerberus.bg-dark{\r\n    background-color:#212529 !important;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6{\r\n    margin-bottom:0px !important;\r\n}\r\n\r\n.row{\r\n    margin-left:0px !important; \r\n    margin-right:0px !important;\r\n}\r\n\r\n.cerberus .row > * {\r\n//   padding-right: 0 !important;\r\n//   padding-left: 0 !important;\r\n}\r\n\r\n.account-created-modal .modal-body{\r\n    min-height:unset !important;\r\n}\r\n\r\n.fade{\r\n    opacity: unset;\r\n}\r\n\r\n\r\n.response-blur {\r\n  filter: blur(8px);\r\n  -webkit-filter: blur(8px);\r\n}\r\n\r\n\r\n.modal.fade{\r\n    opacity : 1 !important;\r\n    z-index:1051 !important;\r\n}\r\n\r\n.modal-backdrop.fade{\r\n    opacity:1 !important;\r\n    background:rgba(0,0,0,0.8) !important;\r\n}\r\n\r\n.modal-body::after {\r\n  display:none;\r\n}\r\n\r\n.authentication-dropdown-tabs .nav-tabs{\r\n  border-bottom: 1px solid rgba(255,255,255,0.3) !important;\r\n}\r\n\r\n\r\n.authentication-dropdown-tabs .nav-item {\r\n  margin-right: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n\r\n.authentication-dropdown-tabs .nav-link{\r\n  background: #212529 !important;  \r\n  color: #fff !important;\r\n  border: 1px solid transparent !important; \r\n  border-bottom-color: rgba(255,255,255,0.3) !important;\r\n  border-radius: 5px 5px 0 0 !important;\r\n  margin-right: 0 !important;\r\n  position: relative !important;\r\n  z-index: 1 !important; \r\n  transition: all .25s ease !important;\r\n}\r\n\r\n\r\n.authentication-dropdown-tabs .nav-link:hover,\r\n.authentication-dropdown-tabs .nav-link.active{\r\n  z-index: 2 !important;\r\n    border: 1px solid rgba(255,255,255,0.3) !important;\r\n    border-bottom-color:#212529 !important;\r\n}\r\n\r\nbody.discover-popover-open{\r\n    overflow:hidden;\r\n}\r\n.site-footer-modal{\r\n    min-height:90vh;\r\n}\r\n\r\n.modal-dialog{\r\n    margin-top:56px !important;\r\n}\r\n\r\n.modal-content{\r\n    max-height:90vh;\r\n}\r\n\r\n.site-footer-modal a{\r\n    text-decoration: none;\r\n    color : #2b2b2b;\r\n}\r\n\r\n\r\n.slide-container {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.slide-content {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  transition: transform 0.5s ease;\r\n}\r\n\r\n.slide-content.enter-left {\r\n  transform: translateX(-100%);\r\n}\r\n.slide-content.enter-right {\r\n  transform: translateX(100%);\r\n}\r\n.slide-content.active {\r\n  transform: translateX(0);\r\n}\r\n\r\n#discover-dropdown .collapsing > *, #discover-dropdown .collapsing{\r\n    height : unset !important;\r\n}\r\n\r\n\r\n.rotate-180 {\r\n    transform: rotate(180deg);\r\n    transition: transform .25s ease;\r\n}\r\n\r\n#siteSearch li{\r\n    cursor: pointer;\r\n     transition: background 0.3s ease;\r\n}\r\n#siteSearch li:hover, \r\n#siteSearch li.selected{\r\n    background:rgba(255,255,255,0.3);\r\n}\r\n#searchPhrase{\r\n    margin-top:0px !important;\r\n    margin-bottom:0px !important;\r\n    height:unset !important;\r\n    font-family:inherit !important;\r\n}\r\n#searchPhrase::placeholder {\r\n  letter-spacing: 0.4em;\r\n}\r\n\r\n#search-close{\r\n    position:sticky;\r\n    top:0;\r\n    background-color:inherit;\r\n}\r\n\r\n.discover-learn-course, \r\n.discover-lounge-case-study {\r\n    transition: background 0.3s ease;\r\n    background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.discover-learn-course:hover, \r\n.discover-lounge-case-study:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.collapse-chevron {\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.collapse-chevron.rotated {\r\n    transform: rotate(180deg);\r\n}\r\n.discover-carousel-indicator {\r\n    border: 2px solid transparent;\r\n    text-transform: uppercase !important;\r\n    transition: border 0.3s ease, border-color 0.3s ease;\r\n    border-bottom :none !important;\r\n    font-size:0.875em !important;\r\n}\r\n\r\n.discover-carousel-indicator:hover,\r\n.discover-carousel-indicator.active {\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n    background:#212529 !important;\r\n}\r\n\r\n\r\n.featured-blog-post{\r\n    background: linear-gradient(135deg, #ffca2c, #ff9900);\r\n    color: #000;\r\n    font-weight: 700;\r\n    font-size: .75rem;\r\n    padding: .35rem .6rem;\r\n    border-radius: .35rem;\r\n    box-shadow: 0 0 6px rgba(0,0,0,.6);\r\n    letter-spacing: .5px;\r\n    text-transform: uppercase;\r\n\r\n    /* optional subtle border */\r\n    border: 1px solid rgba(255,255,255,.15);\r\n\r\n    /* optional shine … subtle but nice on black */\r\n    backdrop-filter: blur(3px);\r\n}\r\n\r\nbutton{\r\n    width:unset;\r\n    height:unset;\r\n}\r\n\r\n\r\n.authentication-enrol-tabs .nav-link, .authentication-create-tabs .nav-link {\r\n    /*background: #212529 !important;*/\r\n    color: #fff !important;\r\n    border: 1px solid transparent;\r\n    border-bottom-color: rgba(255,255,255,0.3);\r\n    border-radius: 5px 5px 0 0;\r\n    margin-right: 0;\r\n    position: relative;\r\n    z-index: 1;\r\n    transition: all .25s ease;\r\n}\r\n\r\n\r\n    .authentication-enrol-tabs .nav-link:hover,\r\n    .authentication-enrol-tabs .nav-link.active,\r\n    .authentication-create-tabs .nav-link:hover,\r\n    .authentication-create-tabs .nav-link.active {\r\n        z-index: 2;\r\n        border: 1px solid rgba(255,255,255,0.7) !important;\r\n        border-top-right-radius:5px !important;\r\n        border-top-left-radius:5px !important;\r\n        border-bottom-color: #212529 !important;\r\n        background:transparent !important;\r\n    }\r\n\r\n\r\n\r\n#discover-dropdown{\r\n    transform:none !important;\r\n    position:fixed !important;\r\n    top:56px !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Snowflakes relative to container */\r\n.snowflake {\r\n    position: absolute; /* relative to container */\r\n    top: -10%;          /* start slightly above container */\r\n    z-index: 9999;\r\n    color: #fff;\r\n    font-size: 1em;\r\n    font-family: Arial, sans-serif;\r\n    text-shadow: 0 0 5px #000;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n    cursor: default;\r\n    pointer-events: none;\r\n    animation-name: snowflakes-shake;\r\n    animation-duration: 3s;\r\n    animation-timing-function: ease-in-out;\r\n    animation-iteration-count: infinite;\r\n    animation-play-state: running;\r\n}\r\n\r\n@keyframes snowflakes-fall {\r\n    0% {\r\n        transform: translateY(-10%) translateX(0);\r\n        opacity: 0;\r\n    }\r\n    10% {\r\n        opacity: 1;\r\n    }\r\n    90% {\r\n        opacity: 1;\r\n    }\r\n    100% {\r\n        transform: translateY(110%) translateX(5px); /* small horizontal drift */\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.snowflake .inner {\r\n    animation-name: snowflakes-fall;\r\n    animation-duration: 3s;  /* you can randomize per flake */\r\n    animation-timing-function: linear;\r\n    animation-iteration-count: infinite;\r\n}\r\n\r\n/* Snowflake positions and delays */\r\n.snowflake:nth-of-type(1) { left: 1%; animation-delay: 0s; }\r\n.snowflake:nth-of-type(1) .inner { animation-delay: 0s; }\r\n.snowflake:nth-of-type(2) { left: 10%; animation-delay: 1s; }\r\n.snowflake:nth-of-type(2) .inner { animation-delay: 1s; }\r\n.snowflake:nth-of-type(3) { left: 20%; animation-delay: 0.5s; }\r\n.snowflake:nth-of-type(3) .inner { animation-delay: 2s; }\r\n.snowflake:nth-of-type(4) { left: 30%; animation-delay: 2s; }\r\n.snowflake:nth-of-type(4) .inner { animation-delay: 3s; }\r\n.snowflake:nth-of-type(5) { left: 40%; animation-delay: 1.5s; }\r\n.snowflake:nth-of-type(5) .inner { animation-delay: 2.5s; }\r\n// .snowflake:nth-of-type(6) { left: 50%; animation-delay: 3s; }\r\n// .snowflake:nth-of-type(6) .inner { animation-delay: 4s; }\r\n.snowflake:nth-of-type(7) { left: 60%; animation-delay: 2s; }\r\n.snowflake:nth-of-type(7) .inner { animation-delay: 3.5s; }\r\n.snowflake:nth-of-type(8) { left: 70%; animation-delay: 1s; }\r\n.snowflake:nth-of-type(8) .inner { animation-delay: 2s; }\r\n.snowflake:nth-of-type(9) { left: 80%; animation-delay: 0s; }\r\n.snowflake:nth-of-type(9) .inner { animation-delay: 1s; }\r\n.snowflake:nth-of-type(10) { left: 90%; animation-delay: 1.5s; }\r\n.snowflake:nth-of-type(10) .inner { animation-delay: 2.5s; }\r\n.snowflake:nth-of-type(11) { left: 25%; animation-delay: 0.5s; }\r\n.snowflake:nth-of-type(11) .inner { animation-delay: 1.5s; }\r\n.snowflake:nth-of-type(12) { left: 65%; animation-delay: 2.5s; }\r\n.snowflake:nth-of-type(12) .inner { animation-delay: 3.5s; }\r\n\r\n/* Optional shimmer animation for text */\r\n@keyframes shimmer {\r\n0% { text-shadow: 2px 2px 5px rgba(0,0,0,0.3), 0 0 10px #FFCC00, 0 0 15px #D72631; }\r\n50% { text-shadow: 2px 2px 5px rgba(0,0,0,0.3), 0 0 20px #FFCC00, 0 0 30px #D72631; }\r\n100% { text-shadow: 2px 2px 5px rgba(0,0,0,0.3), 0 0 10px #FFCC00, 0 0 15px #D72631; }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n@media (max-width: 991px) {\r\n  .navbar-brand::after{\r\n    margin-left:10px !important;\r\n    padding-left:0px !important;\r\n  }\r\n  \r\n}\r\n\r\n@media (max-width: 768px) {\r\n    #discover-dropdown{\r\n        position:fixed !important;\r\n        transform:none !important;\r\n        top:56px !important;\r\n        height:calc(100vh - 56px) !important;\r\n    }\r\n    #discover-dropdown .cerberus-carousel-indicators{\r\n        display:flex !important;\r\n        height:40px;\r\n        display:flex;\r\n        justify-content: center;\r\n        align-items:center;\r\n        margin-left:auto;\r\n        margin-right:auto;\r\n    }\r\n    #site-account-dropdown{\r\n        width:100vw !important;\r\n    }\r\n    #site-navbar-content-wrapper{\r\n        height:calc(100vh - 56px);\r\n    }\r\n     #site-navbar-content{\r\n        position:fixed;\r\n        top:56px;\r\n        right:0px;\r\n        left:0px;\r\n        bottom:0px;\r\n    }\r\n\r\n    .navbar-collapse.collapsing .navbar-collapse-inner, .navbar-collapse.show .navbar-collapse-inner{\r\n        height:calc(100vh - 56px);\r\n    }\r\n}\r\n\r\n\r\n\r\n@media (max-width: 480px) {\r\n  .nav-tabs > li {\r\n    width:auto !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
